// Mock data for architecture portfolio

export const projects = [
  {
    id: 1,
    title: "Skyline Corporate Tower",
    category: "commercial",
    location: "New York, USA",
    year: "2024",
    area: "45,000 sq ft",
    image: "https://images.unsplash.com/photo-1674981208693-de5a9c4c4f44",
    thumbnail: "https://images.unsplash.com/photo-1674981208693-de5a9c4c4f44?w=600&h=400&fit=crop",
    description: "A landmark commercial tower featuring sustainable design principles and innovative structural solutions. The building incorporates energy-efficient systems and provides flexible workspace environments for modern businesses.",
    client: "Skyline Developments",
    services: ["Architecture Design", "Interior Planning", "Sustainability Consulting"],
    gallery: [
      "https://images.unsplash.com/photo-1674981208693-de5a9c4c4f44",
      "https://images.unsplash.com/photo-1672152567793-b6b91e2ce514",
      "https://images.unsplash.com/photo-1672152567751-71ea0298e821"
    ]
  },
  {
    id: 2,
    title: "Metropolitan Office Complex",
    category: "corporate",
    location: "London, UK",
    year: "2023",
    area: "68,000 sq ft",
    image: "https://images.unsplash.com/photo-1672152567793-b6b91e2ce514",
    thumbnail: "https://images.unsplash.com/photo-1672152567793-b6b91e2ce514?w=600&h=400&fit=crop",
    description: "A contemporary office complex designed to foster collaboration and innovation. Features include state-of-the-art facilities, green terraces, and intelligent building management systems.",
    client: "Metropolitan Holdings",
    services: ["Master Planning", "Architecture Design", "Project Management"],
    gallery: [
      "https://images.unsplash.com/photo-1672152567793-b6b91e2ce514",
      "https://images.unsplash.com/photo-1638571179295-62c1ba683441",
      "https://images.pexels.com/photos/14526255/pexels-photo-14526255.jpeg"
    ]
  },
  {
    id: 3,
    title: "Innovation Hub",
    category: "institutional",
    location: "Singapore",
    year: "2024",
    area: "52,000 sq ft",
    image: "https://images.unsplash.com/photo-1762075314840-df83c48bbde8",
    thumbnail: "https://images.unsplash.com/photo-1762075314840-df83c48bbde8?w=600&h=400&fit=crop",
    description: "A cutting-edge research and education facility designed to inspire creativity and collaboration. The building features flexible learning spaces, advanced laboratories, and sustainable design elements.",
    client: "National University",
    services: ["Architecture Design", "Interior Design", "Acoustic Consulting"],
    gallery: [
      "https://images.unsplash.com/photo-1762075314840-df83c48bbde8",
      "https://images.unsplash.com/photo-1764079833194-aa524e3b68b6",
      "https://images.unsplash.com/photo-1759441876689-aa8e847a3ae3"
    ]
  },
  {
    id: 4,
    title: "International Transit Center",
    category: "transportation",
    location: "Dubai, UAE",
    year: "2023",
    area: "125,000 sq ft",
    image: "https://images.pexels.com/photos/28991580/pexels-photo-28991580.jpeg",
    thumbnail: "https://images.pexels.com/photos/28991580/pexels-photo-28991580.jpeg?w=600&h=400&fit=crop",
    description: "A world-class transportation hub designed for efficiency and passenger experience. Features seamless connectivity, natural lighting, and innovative wayfinding systems.",
    client: "Dubai Transport Authority",
    services: ["Master Planning", "Architecture Design", "Structural Engineering"],
    gallery: [
      "https://images.pexels.com/photos/28991580/pexels-photo-28991580.jpeg",
      "https://images.pexels.com/photos/34269885/pexels-photo-34269885.jpeg",
      "https://images.unsplash.com/photo-1560179707-f14e90ef3623"
    ]
  },
  {
    id: 5,
    title: "Heritage Corporate Plaza",
    category: "commercial",
    location: "Chicago, USA",
    year: "2022",
    area: "38,000 sq ft",
    image: "https://images.unsplash.com/photo-1672152567751-71ea0298e821",
    thumbnail: "https://images.unsplash.com/photo-1672152567751-71ea0298e821?w=600&h=400&fit=crop",
    description: "A modern interpretation of classical architecture, blending historical context with contemporary design. The building respects its urban setting while providing modern amenities.",
    client: "Heritage Properties",
    services: ["Architecture Design", "Historic Preservation", "Urban Planning"],
    gallery: [
      "https://images.unsplash.com/photo-1672152567751-71ea0298e821",
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
      "https://images.pexels.com/photos/14711251/pexels-photo-14711251.jpeg"
    ]
  },
  {
    id: 6,
    title: "Tech Campus Headquarters",
    category: "corporate",
    location: "San Francisco, USA",
    year: "2024",
    area: "92,000 sq ft",
    image: "https://images.unsplash.com/photo-1638571179295-62c1ba683441",
    thumbnail: "https://images.unsplash.com/photo-1638571179295-62c1ba683441?w=600&h=400&fit=crop",
    description: "An innovative corporate headquarters designed for a leading technology company. Features include open collaborative spaces, wellness amenities, and cutting-edge sustainable technologies.",
    client: "Tech Innovations Inc.",
    services: ["Master Planning", "Architecture Design", "Landscape Architecture"],
    gallery: [
      "https://images.unsplash.com/photo-1638571179295-62c1ba683441",
      "https://images.pexels.com/photos/14526255/pexels-photo-14526255.jpeg",
      "https://images.unsplash.com/photo-1560179707-f14e90ef3623"
    ]
  },
  {
    id: 7,
    title: "Cultural Center",
    category: "institutional",
    location: "Paris, France",
    year: "2023",
    area: "42,000 sq ft",
    image: "https://images.unsplash.com/photo-1774627895246-954869462964",
    thumbnail: "https://images.unsplash.com/photo-1774627895246-954869462964?w=600&h=400&fit=crop",
    description: "A community cultural center designed to serve as a gathering place for arts, education, and social engagement. The building features flexible performance spaces and exhibition galleries.",
    client: "City of Paris",
    services: ["Architecture Design", "Acoustic Design", "Interior Design"],
    gallery: [
      "https://images.unsplash.com/photo-1774627895246-954869462964",
      "https://images.unsplash.com/photo-1764079833194-aa524e3b68b6",
      "https://images.unsplash.com/photo-1762075314840-df83c48bbde8"
    ]
  },
  {
    id: 8,
    title: "Regional Airport Terminal",
    category: "transportation",
    location: "Barcelona, Spain",
    year: "2022",
    area: "158,000 sq ft",
    image: "https://images.pexels.com/photos/34269885/pexels-photo-34269885.jpeg",
    thumbnail: "https://images.pexels.com/photos/34269885/pexels-photo-34269885.jpeg?w=600&h=400&fit=crop",
    description: "A modern airport terminal designed for passenger comfort and operational efficiency. Features include natural lighting, efficient circulation patterns, and sustainable climate control systems.",
    client: "Barcelona Airport Authority",
    services: ["Architecture Design", "Structural Engineering", "MEP Design"],
    gallery: [
      "https://images.pexels.com/photos/34269885/pexels-photo-34269885.jpeg",
      "https://images.pexels.com/photos/28991580/pexels-photo-28991580.jpeg",
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab"
    ]
  }
];

export const categories = [
  { id: 'all', label: 'All Projects' },
  { id: 'commercial', label: 'Commercial' },
  { id: 'corporate', label: 'Corporate' },
  { id: 'institutional', label: 'Institutional' },
  { id: 'transportation', label: 'Transportation' }
];

export const timeSlots = [
  '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM',
  '02:00 PM', '03:00 PM', '04:00 PM', '05:00 PM'
];

export const aboutData = {
  title: "Creating Spaces That Inspire",
  description: "With over two decades of experience in architectural design, we specialize in creating innovative, sustainable, and functional spaces that enhance the built environment. Our approach combines thoughtful design with technical excellence to deliver projects that exceed expectations.",
  expertise: [
    "Commercial Architecture",
    "Corporate Office Design",
    "Institutional Buildings",
    "Transportation Infrastructure",
    "Master Planning",
    "Sustainable Design"
  ],
  stats: [
    { number: "150+", label: "Projects Completed" },
    { number: "25+", label: "Years Experience" },
    { number: "40+", label: "Design Awards" },
    { number: "20+", label: "Countries" }
  ]
};